import * as yup from 'yup';

export const headingInitialValues = {
    content: 'Heading',
    variant: 'h2',
};

export const headingForm = [
    {
        id: '1',
        label: 'content',
        name: 'content',
        type: 'text',
        component: 'FormikTextField',
    },
    {
        id: '2',
        label: 'variant',
        name: 'variant',
        placeholder: 'Select Size',
        component: 'FormikSelect',
        items: [
            {
                value: 'h1',
                label: 'h1',
            },
            {
                value: 'h2',
                label: 'h2',
            },
            {
                value: 'h3',
                label: 'h3',
            },
            {
                value: 'h4',
                label: 'h4',
            },
            {
                value: 'h5',
                label: 'h5',
            },
            {
                value: 'h6',
                label: 'h6',
            },
        ],
    },
];

export const headingValidation = {
    content: yup
        .string()
        .matches(/^[a-zA-Z0-9 ]*$/, 'Alphanumeric characters only')
        .required(),
};
